// import {FormattedRelativeTime} from "react-intl";
import React from "react";
import FormattedRelativeTime from "@/components/FormattedRelativeTime.tsx";

const ONE_DAY = 24 * 60 * 60 * 1000;
const ONE_HOUR = 60 * 60 * 1000;
const ONE_MINUTE = 60 * 1000;
const ONE_MONTH = 30 * ONE_DAY;
function relativeTime(time): {unit: Intl.RelativeTimeFormatUnit, value: number} {
    const diff = new Date(time).getTime() - Date.now();
    const absDiff = Math.abs(diff);
    if(absDiff > ONE_MONTH) {
        return {
            unit: 'month',
            value: Math.floor(diff / ONE_MONTH)
        }
    }
    if(absDiff > ONE_DAY){
        return {
            unit:'day',
            value: Math.floor(diff / ONE_DAY)
        }
    }else if(absDiff > ONE_HOUR) {
        return {
            unit: 'hour',
            value: Math.floor(diff / ONE_HOUR)
        }
    }else if(absDiff > ONE_MINUTE) {
        return {
            unit: 'minute',
            value: Math.floor(diff / ONE_MINUTE)
        }
    }else{
        return {
            unit:'seconds',
            value: Math.floor(diff / 1000)
        }
    }
}

export default function DisplayRelativeTime({time}: {
    time: string
}){

    if(!time) return null;
    return       <FormattedRelativeTime
        style={'long'}
        {...relativeTime(time)}/>
}
